import { useTranslation } from "react-i18next";
import { TaskList } from "services/cabinet.service";
import {
  leaveCalendarLeaveTypeI18nKey,
  normalizeLeaveTypeCode,
} from "features/leave-calendar/leaveCalendar.constants";
import TaskRow, { taskAge, Translate } from "./task-row";
import TasksSection from "./tasks-section";

/** «Laukia kitų»: the person's own requests that wait for somebody's approval. Nothing to press here. */
export default function WaitingOthersList({ waiting }: { waiting: TaskList }) {
  const { t } = useTranslation();
  if (waiting.items.length === 0) return null;

  return (
    <TasksSection title={`${t("tasks_section_waiting_others")} (${waiting.count})`}>
      <ul className="space-y-2">
        {waiting.items.map((item) => (
          <TaskRow
            key={item.id}
            title={leaveTypeName(item.title, t)}
            meta={taskAge(item.since, t)}
            chips={[t("tasks_waiting_approval")]}
            muted
          />
        ))}
      </ul>
    </TasksSection>
  );
}

/** The backend sends the leave type code ("additional rest time"); people read its name. */
function leaveTypeName(code: string, t: Translate): string {
  return t(leaveCalendarLeaveTypeI18nKey(normalizeLeaveTypeCode(code)), { defaultValue: code });
}
